const LEAD_URL = "/api/verity/demo/lead";

export type DemoLead = {
	firstName: string;
	lastName: string;
	email: string;
	organization: string;
	role: string;
	phoneNumber: string;
};

/** Resolves on `204`. Every other response throws so the form can keep the typed values and say so. */
export async function submitDemoLead(lead: DemoLead): Promise<void> {
	const response = await fetch(LEAD_URL, {
		method: "POST",
		credentials: "omit",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(lead),
	});
	if (!response.ok) {
		throw new Error(`POST ${LEAD_URL} responded ${response.status}`);
	}
}
